import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import './AdminDashboard.css';

export default function AdminLogin() {
  const { admin, login, loading, error, clearError } = useAdminAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });

  useEffect(() => {
    if (admin) navigate('/admin/dashboard', { replace: true });
  }, [admin, navigate]);

  const onChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    clearError();
    try {
      await login(form.email, form.password);
      navigate('/admin/dashboard', { replace: true });
    } catch { /* shown via error */ }
  };

  return (
    <div className="admin-auth-page">
      <form className="admin-auth-card" onSubmit={onSubmit}>
        <div className="admin-auth-brand">🛡️</div>
        <h1>Super Admin</h1>
        <p className="admin-auth-sub">Restricted access — authorized personnel only.</p>

        {error && <div className="admin-auth-error">{error}</div>}

        <label>Email</label>
        <input type="email" name="email" value={form.email} onChange={onChange} required autoFocus />

        <label>Password</label>
        <input type="password" name="password" value={form.password} onChange={onChange} required />

        <button type="submit" className="admin-auth-btn" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>

        <p className="admin-auth-note">
          Admin accounts are created via <code>php-apis/setup.php</code> or directly in the <code>admins</code> table.
        </p>
      </form>
    </div>
  );
}
